import React, {Component} from 'react';
import FocusPageId from "../../FocusPageId";
import {Link} from "react-router-dom";

let i = 0;

class ProductSpecifications extends React.Component {
    componentDidMount() {
        // window.scrollTo(0, 0);
        let element = document.getElementById(FocusPageId.selectedId.elementId);
        element.scrollIntoView(true);
        element.classList.add('mystyle');
        // element.style.paddingTop="50px"
        window.scrollTo({
            top: document.getElementById(FocusPageId.selectedId.elementId).offsetTop - 40,
            behavior: 'smooth'
        });


    }

    constructor(props) {
        super(props);

        this.positionAdject = this.positionAdject.bind()
    };

    positionAdject = () => {
        i++;
        // if(i<3){
        //     document.getElementById(FocusPageId.selectedId.elementId).style.paddingTop="0px";

        // }

    };

    render() {

        return (
            <div className="static-pages" onWheel={() => this.positionAdject()}>
                <div className="background-div">
                    <h3><b>
                        <li>製品仕様について</li>
                    </b></h3>
                    <div className="brElement"></div>
                    <div className="brElement"></div>
                    <h4 id="a1"><b>
                        KITCUT PCB 注文番号とは

                    </b>
                    </h4>
                    <p className='all-content-font-size'> 他の顧客との商品と取り間違いを避けるために、KITCUTではランダムな注文番号が基板に
                        追加されますことご理解下さい、捨て基板がある場合は、捨て基板に配置されます。
                    </p>
                    <p className='all-content-font-size'>（注文番号シルクフォントサイズは、高さ0.8mm、線幅0.15mmです）</p>
                    <p className='all-content-font-size'> ※捨て基板を付けることにより、実装効率が上がったり、不良を減らすことができますので、基板データに捨て基板を配置する事をおすすめします。
                    </p>


                    <div className="brElement"></div>
                    <h4 id="a"><b> 基板製造サービス仕様以外の基板製造はお願いできますか？</b>
                    </h4>
                    <p className='all-content-font-size'>お受けすることができません。
                    </p>
                    <p className='all-content-font-size'> キットカットPCBでは、製造枚数、製造仕様（基材、層数、シルク等）可能な限りの仕様共通化を図り、製造環境を整備することによって最終
                    </p>
                    <p className='all-content-font-size'> 製造コストを削減し、お客様の開発費用削減に貢献いたします。
                    </p>

                    <div className="brElement"></div>
                    <h4 id="b"><b> 基板の最大製造寸法は？</b>
                    </h4>
                    {/*<p className='all-content-font-size'>片面／両面基板は400mm×500mmです、4層／6層基板は390mm×390mmです。*/}
                    {/*</p>  */}
                    <p className='all-content-font-size'>
                        片面・両面・4層・6層基板は400mm×500mmです。
                    </p>
                    <p>
                        ※Vカットによるシート面付の場合、最小サイズ70mm×70mm以上、最大サイズ400mm×400mmです。
                    </p>

                    <div className="brElement"></div>
                    <h4 id="c"><b> 外形加工、Vカット寸法公差は？</b>
                    </h4>
                    <p className='all-content-font-size'>±0.2mmです。
                    </p>
                    <p className='all-content-font-size'> 100mm以下±0.2mm、100mm以上50mmまでの寸法増加ごとに0.1mmプラスされます。
                    </p>

                    <div className="brElement"></div>
                    <h4 id="d"><b> レジスト印刷の色は指定できますか？</b>
                    </h4>
                    <p className='all-content-font-size'>はい、できます。弊社レジストカラー6色よりお選びください。（緑・赤・白・黄・青・黒）
                    </p>

                    <div className="brElement"></div>
                    <h4 id="e"><b> シルク印刷の色は指定できますか？</b>
                    </h4>
                    <p className='all-content-font-size'>いいえ、できません。お選び頂いたレジスト色でシルク色が決まります。
                    </p>
                    <p className='all-content-font-size'> レジスト色が緑・赤・黄・青・黒の場合、シルク色は白になります。
                    </p>
                    <p className='all-content-font-size'> レジスト色が白の場合、シルク色は黒になります。
                    </p>

                    <div className="brElement"></div>
                    <h4 id="f"><b> 最小パターン幅を教えてください。</b>
                    </h4>
                    <p className='all-content-font-size'>0.08mmです。
                    </p>
                    <p className='all-content-font-size'> 片面、両面基板の場合、最小パターン幅0.127mm、多層基板の場合、最小パターン幅0.08mm
                    </p>

                    <div className="brElement"></div>
                    <h4 id="g"><b> 最小パターン間隔を教えてください。</b>
                    </h4>
                    <p className='all-content-font-size'>0.08mmです。片面、両面基板の場合、最小パターン間隔0.127mm。多層基板の場合、最小パターン間隔0.08mm。
                    </p>

                    <div className="brElement"></div>
                    <h4 id="h"><b> 最小ビア径を教えてください。</b>
                    </h4>
                    <p className='all-content-font-size'>0.2mmです。片面、両面基板の場合、最小ビア径Φ0.3/0.6mm。多層基板の場合、最小ビア径Φ0.2mm/0.45mm。
                    </p>

                    <div className="brElement"></div>
                    <h4 id="i"><b> 最小ランド径を教えてください。</b>
                    </h4>
                    <p className='all-content-font-size'>0.45mmです。片面、両面基板の場合、最小ランド径0.6mm。多層基板の場合 最小ランド径0.45mm。
                    </p>

                    <div className="brElement"></div>
                    <h4 id="j"><b> 最小パターン間隔を教えてください。</b>
                    </h4>
                    <p className='all-content-font-size'>0.127mmです。パターン-ランド間隔、ランド-ランド間隔。
                    </p>

                    <div className="brElement"></div>
                    <h4 id="k"><b> 最小、最大のドリル穴径を教えてください。</b>
                    </h4>
                    <p className='all-content-font-size'>最小ドリル径0.2mmで、最大ドリル径6.3mmです。
                    </p>

                    <div className="brElement"></div>
                    <h4 id="l"><b> ガーバーデータの出力形式の指定はありますか？</b>
                    </h4>
                    <p className='all-content-font-size'>キットカットPCBでは拡張ガーバー【RS-274X】形式のみの受け入れとなります。
                    </p>
                    <p className='all-content-font-size'> ドリルデータはEXCELLON形式で出力してください。
                    </p>
                    <p className='all-content-font-size'> アップロードファイルは最大4MBです。
                    </p>

                    <div className="brElement"></div>
                    <h4 id="m"><b> ガーバーデータは等倍で出力するのですか？</b>
                    </h4>
                    <p className='all-content-font-size'>はい、ガーバーデータとドリルデータは等倍（原寸）で出力してください。
                    </p>

                    <div className="brElement"></div>
                    <h4 id="n"><b>ガーバーデータ・ドリルデータの単位、出力桁数について教えてください。</b>
                    </h4>
                    <p className='all-content-font-size'>ガーバーデータ・ドリルデータは、全て単位、桁数で統一しないと、描画・データ読み込み不良を起こすことがあります。
                    </p>

                    <div className="brElement"></div>
                    <h4 id="o"><b>最小シルク文字幅について教えてください。</b>
                    </h4>
                    <p className='all-content-font-size'>最小0.15mmです、0.15mm未満の文字幅は文字が潰れて識別出来ません。
                    </p>

                    <div className="brElement"></div>
                    <h4 id="p"><b>最小シルク文字高について教えてください。</b>
                    </h4>
                    <p className='all-content-font-size'>最小1.0mmです、1.0mm未満の文字高は文字が潰れて識別出来ません。
                    </p>

                    <div className="brElement"></div>
                    <h4 id="q"><b> 外形から銅箔までの推奨距離を教えてください。</b>
                    </h4>
                    <p className='all-content-font-size'>基板端面から銅箔部（パターン、ベタ）まで0.3mm以上離してください。
                    </p>

                    <div className="brElement"></div>
                    <h4 id="r"><b>Vカットセンターから銅箔部（パターン、ベタ）までの推奨距離を教えてください。</b>
                    </h4>
                    <p className='all-content-font-size'>0.5mm以上推奨
                    </p>

                    <div className="brElement"></div>
                    <h4 id="s"><b>外形線幅について教えてください。</b>
                    </h4>
                    <p className='all-content-font-size'>外形ガーバーデータに、線幅 0.2mm で基板外形線を作成してください。外形ガーバーデータに描かれた、線の中心を切削します。
                    </p>

                    <div className="brElement"></div>
                    <h4 id="t"><b> Vカット線幅について教えてください。</b>
                    </h4>
                    <p className='all-content-font-size'>外形線ガーバーデータ内に、線幅 0.5mm の V カット線を作成してください。
                    </p>

                    <div className="brElement"></div>
                    <h4 id="u"><b>ルーター外形について教えてください。</b>
                    </h4>
                    <p className='all-content-font-size'>同種異種問わず複数面付けされたデータでルーターによる外形加工する場合は、基板と基板の間隔は2.0mm以上あけて配置してください。
                    </p>

                    <div className="brElement"></div>
                    <h4 id="v"><b>捨て基板について教えてください。</b>
                    </h4>
                    <p className='all-content-font-size'>3.0mmの場合、分割する際に困難になりますので、余裕を持って5.0mm以上で設計することを推奨します。
                    </p>
                    <p className='all-content-font-size'> 実装認識マークを配置する場合は捨て基板は、10.0mmで設計することを推奨します。
                    </p>

                    <div className="brElement"></div>
                    <h4 id="w"><b> 外形データ描画について教えてください。</b>
                    </h4>
                    <p className='all-content-font-size'>メッキの無い（NPTH）が多い場合は外形データと合成させて下さい。
                    </p>

                    <div className="brElement"></div>
                    {/*<h4  id="x"><b> 端面するホールについて教えてください。</b>*/}
                    <h4 id="x"><b> 端面スルーホールについて教えてください。</b>
                    </h4>
                    <p className='all-content-font-size'>端面スルーホールは特殊技術なので、端面スルーホールの直径は0.6mm以上にして下さい。
                    </p>

                    <div className="brElement"></div>
                    <h4 id="y"><b> 穴埋め（POH）基板について？</b>
                    </h4>
                    <p className='all-content-font-size'>対応しておりません。
                    </p>

                    <div className='col-md-10'></div>
                    <div className='col-md-2 col-12-custom'>
                        <Link to="/productspecificationsTopic">
                            <span className='font-size-20'>
                            戻る
                            </span>
                        </Link>
                    </div>
                </div>
            </div>
        );
    }
}

export default ProductSpecifications;




// WEBPACK FOOTER //
// ./src/components/Site/SiteRoot/Navigation/LinkPages/FaqPages/ProductSpecifications.js